import * as React from 'react';
import '../playerstatselection.css'
import {SimSkillOrder} from "../../fbobjects/calculation/SkillOrder";

interface SkillOrderComponentProps {
    skillOrder:SimSkillOrder
}

const SkillOrderByLevel=({so}: {so:string})=>{
    let ths:any[] = [];
    let tds:any[] = [];
    for(let i = 1; i <= 18; i++){
        ths.push(<th className="table-header" key={i}>{i}</th>);
        tds.push(<td className="table-column" key={i}>{so[i-1]}</td>);
    }

    return <table className="skill-order-table">
        <thead>
        <tr className="table-headers">{ths}</tr>
        </thead>
        <tbody>
        <tr className="table-columns">{tds}</tr>
        </tbody>
    </table>
};



export default class SkillOrderComponent extends React.Component<SkillOrderComponentProps,any> {

    render(){
        return(
            <div className="skill-order">
                <div>
                    <SkillOrderByLevel so={this.props.skillOrder.order} />
                </div>
                {/*<div className="divider"/>*/}
                {/*<div className="when">*/}
                    {/*{this.props.skillOrder.when}*/}
                {/*</div>*/}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/SkillOrderComponent/index.tsx